// removed by extract-text-webpack-plugin
module.exports = {"cardContent":"CardContent__cardContent__2_x8X"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Card/CardContent/CardContent.scss
// module id = 1632
// module chunks = 0